module.exports = require("core-js/library/fn/number/is-integer");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/number/is-integer.js
// module id = 737
// module chunks = 0 15 16 17 18